import type { TrackAssessmentResult } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (assessmentData: TrackAssessmentResult | null) => {
  useRegisterAgentContext({
    kind: 'form',
    description:
      'Assessment checklist that collects GPA, coursework rigor, test scores, resume, transcript, blueprint, life readiness, and other profile data before running the career track assessment. Shows a progress bar indicating completion percentage. Required items vary by enrollment type (high school vs post-secondary). The "Assess My Track" button is enabled only when all required items are complete.',
    data: {
      assessmentData: assessmentData ?? null,
    },
  });
};
